<div [formGroup]="recordForm" *ngIf="recordForm">
    <p-table #dt [value]="data" dataKey="id" (sortFunction)="customSort($event)" [customSort]="true" [paginator]="showPagination" [rows]="25"
        [first]="first" [showCurrentPageReport]="true" [(selection)]="selectedItem" (onRowSelect)="onRowSelect($event)" binary="true"
        (onRowUnselect)="onRowUnSelect($event)" (onHeaderCheckboxToggle)="selectionAll($event)" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
        (onPage)="pageChange($event)" [rowsPerPageOptions]="[25, 50, 100]" [scrollable]="true" scrollHeight="350px">
        <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let item of header">
                    <th style="width: 4rem" *ngIf="item.key == 'checkbox'">
                        <p-tableHeaderCheckbox />
                    </th>
                    <th *ngIf="item.key != 'checkbox'" pSortableColumn={{item.key}}>
                        <div class="t-title-icon">
                            <span> {{item.title}}</span>
                            <p-sortIcon field={{item.key}} [ngStyle]="{'display': (item.key == 'action' ) ? 'none': (item.key == 'status') ? 'none' :'inline-block'}"></p-sortIcon>
                        </div>
                    </th>
                </ng-container>
                <!-- <th class="action">
                    action
                </th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" let-Data let-editing="editing" formArrayName="record">
            <tr [pSelectableRow]="Data"  [formGroupName]="i" [ngClass]="{'tr-highlight': highlightRecord?.includes(Data.id)}">
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key == 'status'">
                        <p-tag [value]="Data.status.label" [severity]="Data.status.class" />
                    </td>
                    <td *ngIf="key.key == 'checkbox'">
                        <p-tableCheckbox [value]="Data" [pSelectableRow]="Data"/>
                    </td>
                    <td *ngIf="key.key != 'action' && key.key != 'status' && key.editable" [pEditableColumn]="Data[key.key]" [pEditableColumnField]="key.key">
                        <input
                        pInputText
                        [type]="key.type == 'text' ? 'text' : 'number'"
                        [(ngModel)]="Data[key.key]" 
                        [formControlName]="key.key"
                        [ngClass]="{'border-danger':(records.get([i, key.key])?.invalid && (records.get([i, key.key])?.touched || records.get([i, key.key])?.dirty))}"
                        (input)="onChange($event, key.key, Data)"/>
                    </td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && !key.currencyPipe">{{ Data[key.key]?.toString().toUpperCase() }}</td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && key.currencyPipe">{{ Data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                    <td *ngIf="key.key == 'action'">
                    <ul class="action-icons">
                        <ng-container *ngFor="let actionData of Data[key.key]">
                            <li *ngIf="actionData.key == 'edit'">
                            <button (click)="onEdit(Data.id)" [disabled]="actionData.isDisable ? true: false" title="Edit">
                                <p-iconField iconPosition="left">
                                    <p-inputIcon styleClass="pi pi-pen-to-square text-primary" />
                                </p-iconField>
                            </button>
                            </li>
                            <li *ngIf="actionData.key == 'delete'" >
                                <button (click)="onDelete(Data.id)" [disabled]="actionData.isDisable ? true : false" title="Delete">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-trash text-danger" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'view'" >
                                <button (click)="onView(Data)" title="View">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-eye text-info" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'file'" >
                                <button (click)="onFile(Data.id)" title="Download Invoice"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-file text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'receipt'" >
                                <button (click)="onReceipt(Data.id)" title="Invoices"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-receipt" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'image'" >
                                <button (click)="onImage(Data.id)" title="Image">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-image" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'loyalty' && actionData.isDisable == true" >
                                <button (click)="onLoyalty(Data.id)" title="Loyalty">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-bitcoin text-success"  />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'copy' && actionData.isDisable == false">
                                <button (click)="onCopy(Data.id)" title="Copy">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-copy text-primary"  />
                                    </p-iconField>
                                </button>
                            </li>
                        </ng-container>

                    </ul>
                    </td>
                </ng-container>
                <!-- <td>
                    <ul class="action-icons">
                        <li>
                            <a (click)="onEdit(Data.id)">
                                <p-iconField iconPosition="left">
                                    <p-inputIcon styleClass="pi pi-pen-to-square text-primary" />
                                </p-iconField>
                            </a>
                        </li>
                        <li>
                            <a (click)="onDelete(Data.id)">
                                <p-iconField iconPosition="left">
                                    <p-inputIcon styleClass="pi pi-trash text-danger" />
                                </p-iconField>
                            </a>
                        </li>
                    </ul>
                </td> -->

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
                <td [attr.colspan]="header.length + 1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div *ngIf="!recordForm && serverSide == false">
    <p-table #dt [value]="data" dataKey="id" (sortFunction)="customSort($event)" [customSort]="true" [paginator]="showPagination" [rows]="25"
        [first]="first" [showCurrentPageReport]="true" [(selection)]="selectedItem" (onRowSelect)="onRowSelect($event)" binary="true"
        (onRowUnselect)="onRowUnSelect($event)" (onHeaderCheckboxToggle)="selectionAll($event)" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
        (onPage)="pageChange($event)" [rowsPerPageOptions]="[25, 50, 100]" [scrollable]="true" scrollHeight="350px">
        <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let item of header">
                    <th style="width: 4rem" *ngIf="item.key == 'checkbox'">
                        <p-tableHeaderCheckbox />
                    </th>
                    <th *ngIf="item.key != 'checkbox'" pSortableColumn={{item.key}}>
                       <div class="t-title-icon">
                            <span>  {{item.title}}</span>
                            <p-sortIcon field={{item.key}}  [ngStyle]="{'display': (item.key == 'action' ) ? 'none': (item.key == 'status') ? 'none' :'inline-block'}"></p-sortIcon>
                        </div>
                    </th>
                </ng-container>
                <!-- <th class="action">
                    action
                </th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" let-Data let-editing="editing" >
            <tr [pSelectableRow]="Data" [ngClass]="{'tr-highlight': highlightRecord?.includes(Data.id)}">
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key == 'status'">
                        <p-tag [value]="Data.status.label" [severity]="Data.status.class" />
                    </td>
                    <td *ngIf="key.key == 'checkbox'">
                        <p-tableCheckbox [value]="Data" [pSelectableRow]="Data"/>
                    </td>
                    <td *ngIf="key.key != 'action' && key.key != 'status' && key.editable" [pEditableColumn]="Data[key.key]" [pEditableColumnField]="key.key">
                        <input
                        pInputText
                        [type]="key.type == 'text' ? 'text' : 'number'"
                        [(ngModel)]="Data[key.key]"
                        (input)="onChange($event, key.key, Data)"/>
                    </td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && !key.currencyPipe">{{ Data[key.key]?.toString().toUpperCase() }}</td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && key.currencyPipe">{{ Data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                    <td *ngIf="key.key == 'action'">
                    <ul class="action-icons">
                        <ng-container *ngFor="let actionData of Data[key.key]">
                            <li *ngIf="actionData.key == 'edit'">
                            <button (click)="onEdit(Data.id)" [disabled]="actionData.isDisable ? true: false" title="Edit">
                                <p-iconField iconPosition="left">
                                    <p-inputIcon styleClass="pi pi-pen-to-square text-primary" />
                                </p-iconField>
                            </button>
                            </li>
                            <li *ngIf="actionData.key == 'delete'" >
                                <button (click)="onDelete(Data.id)" [disabled]="actionData.isDisable ? true : false" title="Delete">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-trash text-danger" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'view'" >
                                <button (click)="onView(Data)" title="View">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-eye text-info" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'file'" >
                                <button (click)="onFile(Data.id)" title="Download Invoice"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-file text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'receipt'">
                                <button (click)="onReceipt(Data.id)" title="Receipt"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-receipt text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'image'" >
                                <button (click)="onImage(Data.id)" title="Image">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-image text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                             <li *ngIf="actionData.key == 'loyalty' && actionData.isDisable == true" >
                                <button (click)="onLoyalty(Data.id)" title="Loyalty">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-bitcoin text-success" />
                                    </p-iconField>
                                </button>
                            </li>
                             <li *ngIf="actionData.key == 'copy' && actionData.isDisable == false">
                                <button (click)="onCopy(Data.id)" title="Copy">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-copy text-primary"  />
                                    </p-iconField>
                                </button>
                            </li>
                        </ng-container>

                    </ul>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading" >
                <td [attr.colspan]="header.length + 1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div *ngIf="!recordForm && serverSide">
    <p-table #dt [value]="data" dataKey="id" (sortFunction)="customSort($event)" [customSort]="true" [paginator]="showPagination" [rows]="25"
        [first]="first" [showCurrentPageReport]="true" [(selection)]="selectedItem" (onRowSelect)="onRowSelect($event)" binary="true"
        (onRowUnselect)="onRowUnSelect($event)" (onHeaderCheckboxToggle)="selectionAll($event)" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
        (onPage)="pageChange($event)" [rowsPerPageOptions]="[25, 50, 100]" [lazy]="true" (onLazyLoad)="getServer($event)" [totalRecords]="totalRecords" [scrollable]="true" scrollHeight="350px">
        <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let item of header">
                    <th style="width: 4rem" *ngIf="item.key == 'checkbox'">
                        <p-tableHeaderCheckbox />
                    </th>
                    <th *ngIf="item.key != 'checkbox'" pSortableColumn={{item.key}}>
                        <div class="t-title-icon">
                            <span>{{item.title}}</span>
                            <p-sortIcon field={{item.key}}  [ngStyle]="{'display': (item.key == 'action' ) ? 'none': (item.key == 'status') ? 'none' :'inline-block'}"></p-sortIcon>
                        </div>
                    </th>
                </ng-container>
                <!-- <th class="action">
                    action
                </th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" let-Data let-editing="editing" >
            <tr [pSelectableRow]="Data" [ngClass]="{'tr-highlight': highlightRecord?.includes(Data.id)}">
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key == 'status'">
                        <p-tag [value]="Data.status.label" [severity]="Data.status.class" />
                    </td>
                    <td *ngIf="key.key == 'checkbox'">
                        <p-tableCheckbox [value]="Data" [pSelectableRow]="Data"/>
                    </td>
                    <td *ngIf="key.key != 'action' && key.key != 'status' && key.editable" [pEditableColumn]="Data[key.key]" [pEditableColumnField]="key.key">
                        <input
                        pInputText
                        [type]="key.type == 'text' ? 'text' : 'number'"
                        [(ngModel)]="Data[key.key]"
                        (input)="onChange($event, key.key, Data)"/>
                    </td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && !key.currencyPipe">{{ Data[key.key]?.toString().toUpperCase() }}</td>
                    <td *ngIf="key.key != 'status' && key.key != 'action' && !key.editable && key.key != 'checkbox' && key.currencyPipe">{{ Data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                    <td *ngIf="key.key == 'action'">
                    <ul class="action-icons">
                        <ng-container *ngFor="let actionData of Data[key.key]">
                            <li *ngIf="actionData.key == 'edit'">
                            <button (click)="onEdit(Data.id)" [disabled]="actionData.isDisable ? true: false" title="Edit">
                                <p-iconField iconPosition="left">
                                    <p-inputIcon styleClass="pi pi-pen-to-square text-primary" />
                                </p-iconField>
                            </button>
                            </li>
                            <li *ngIf="actionData.key == 'delete'" >
                                <button (click)="onDelete(Data.id)" [disabled]="actionData.isDisable ? true : false" title="Delete">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-trash text-danger" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'view'" >
                                <button (click)="onView(Data)" title="View">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-eye text-info" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'file'" >
                                <button (click)="onFile(Data.id)" title="Download Invoice"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-file text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'receipt'">
                                <button (click)="onReceipt(Data.id)" title="Receipt"  [disabled]="actionData.isDisable ? true : false">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-receipt text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                            <li *ngIf="actionData.key == 'image'" >
                                <button (click)="onImage(Data.id)" title="Image">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-image text-primary" />
                                    </p-iconField>
                                </button>
                            </li>
                             <li *ngIf="actionData.key == 'loyalty' && actionData.isDisable == true" >
                                <button (click)="onLoyalty(Data.id)" title="Loyalty" >
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-bitcoin text-success"  />
                                    </p-iconField>
                                </button>
                            </li>
                             <li *ngIf="actionData.key == 'copy' && actionData.isDisable == false">
                                <button (click)="onCopy(Data.id)" title="Copy">
                                    <p-iconField iconPosition="left">
                                        <p-inputIcon styleClass="pi pi-copy text-primary"  />
                                    </p-iconField>
                                </button>
                            </li>
                        </ng-container>

                    </ul>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading" >
                <td [attr.colspan]="header.length + 1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
